export default "__VITE_ASSET__DPS0DuKw__"